import { Http, Response, URLSearchParams } from '@angular/http';
import { NgModule, Injectable, Inject, OnInit } from '@angular/core';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { CurrencyViewModel, LanguageViewModel, UserPreferencesViewModel, Tuple } from './preferences.model';

@Injectable()
export class GETPreferencesService {
    constructor(private _http: Http) { }

    public getUserPreferences(): Observable<UserPreferencesViewModel> {
        return this._http.get("api/preferences/GetUserPreferences").share().map(
            (response: Response) => <UserPreferencesViewModel>response.json()).catch(this.handleError);
    }

    public getAllLanguages(): Observable<LanguageViewModel[]> {
        return this._http.get('api/preferences/GetAllLanguages').share().map(
            (response: Response) => <LanguageViewModel[]>response.json()).catch(this.handleError);
    }

    public getAllCurrencies(): Observable<CurrencyViewModel[]> {
        return this._http.get('api/preferences/GetAllCurrencies').share().map(
            (response: Response) => <CurrencyViewModel[]>response.json()).catch(this.handleError);
    }

    public saveUserPreferences(preferences: UserPreferencesViewModel): Observable<Tuple> {
        return this._http.post('api/preferences/SaveUserPreferences', preferences).share().map(
            (response: Response) => <Tuple>response.json()).catch(this.handleError);
    }

    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }
}
